import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-55281af3"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fr-summary" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "fr-summary__free" };
import { sep, t } from '@vue/services/interval-lang';
import { bookingState } from '@vue/services/interval-store';
import { computed } from 'vue';
/**
 * 摘要裡的店名去掉品牌前綴，只留分店名。
 *
 * 門市卡片上的名稱可能是「狂一鍋 — 竹北自強」（title 沒含品牌時補上的），
 * 摘要空間窄，重複一次品牌沒有意義。title 本來就含品牌的那些不受影響。
 */
export default /*#__PURE__*/ _defineComponent({
    __name: 'BookingSummary',
    setup(__props) {
        /**
         * 訂位摘要（填資料頁與完成頁共用）。
         *
         * 訂位編號只有建單成功後才有值，所以那一列是有值才顯示；
         * 訂金一律顯示「免訂金」——狂一鍋三品牌走 skipDeposit，不經金流。
         */
        const storeTitle = computed(() => bookingState.storeName.replace('狂一鍋 — ', '').replace('Fondue Retro — ', ''));
        // 時段一律只出示開始時間（2026-08-14 門市決策，與門市卡片上的時段按鈕一致）；
        // 結束時間仍在 bookingState.slot.end 裡，只是不顯示。
        const slotText = computed(() => bookingState.slot ? bookingState.slot.time : t('bk.none'));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(bookingState).orderNo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.sumOrderNo')) + _toDisplayString(_unref(sep)()), 1),
                        _createElementVNode("b", null, _toDisplayString(_unref(bookingState).orderNo), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.sumStore')) + _toDisplayString(_unref(sep)()), 1),
                    _createElementVNode("b", null, _toDisplayString(storeTitle.value), 1)
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.sumDate')) + _toDisplayString(_unref(sep)()), 1),
                    _createElementVNode("b", null, _toDisplayString(_unref(bookingState).date), 1)
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.sumSlot')) + _toDisplayString(_unref(sep)()), 1),
                    _createElementVNode("b", null, _toDisplayString(slotText.value), 1)
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.sumParty')) + _toDisplayString(_unref(sep)()), 1),
                    _createElementVNode("b", null, _toDisplayString(_unref(t)('bk.partyAdult')) + " " + _toDisplayString(_unref(bookingState).adult) + " / " + _toDisplayString(_unref(t)('bk.partyChild')) + " " + _toDisplayString(_unref(bookingState).child), 1)
                ]),
                (_unref(bookingState).childSeat > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.childSeat')) + _toDisplayString(_unref(sep)()), 1),
                        _createElementVNode("b", null, _toDisplayString(_unref(bookingState).childSeat), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('bk.sumDeposit')) + _toDisplayString(_unref(sep)()), 1),
                    _createElementVNode("b", _hoisted_4, _toDisplayString(_unref(t)('bk.free2')), 1)
                ])
            ]));
        };
    }
});
